import { useAppSelector, migrationToSNModalState } from 'src/store';
import { useMemo } from 'react';

export const useMigrationToSNModalState = () => {
  const { shouldShowMigrationToSNModal } = useAppSelector(
    migrationToSNModalState,
  );

  return useMemo(
    () => ({
      shouldShowMigrationToSNModal,
    }),
    [shouldShowMigrationToSNModal],
  );
};
